import React from "react"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

const TopLinkCardDetailTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W3",
  fontSize: "20px",
  lineHeight: "1.45",
  color: "#727272",
}))

const TopLinkCardDetail = (props) => {
  return (
    <TopLinkCardDetailTypography
      variant="body2"
      color="textSecondary"
      component="p"
    >
      {props.detail}
    </TopLinkCardDetailTypography>
  )
}

export default TopLinkCardDetail
